<template>
  <v-dialog
    persistent
    v-model="sendDialog"
    max-width="600px">
    <div class="layerPopup">
      <div v-if="customerTabStat === 'WEBSITE'" href="#WEBSITE" class="layerTit">一回のみ配信：プッシュ通知</div>
      <div v-if="customerTabStat === 'LINE'" href="#LINE" class="layerTit">一回のみ配信：LINE</div>
      <div class="layerContent large">
        <div class="msgCon" v-if="customerTabStat === 'LINE'" >
          <customer-send-line
          ref="sendLine"
          :templateList="templateList"
          :customerList="sendCustomerList"
          :mailSendCheck="mailSendCheck"
          @close="close"
          ></customer-send-line>
        </div>
        <div class="msgCon" v-else-if="customerTabStat === 'WEBSITE'">
          <customer-send-webchat
          ref="sendWebChat"
          :templateList="templateList"
          :customerList="sendCustomerList"
          @close="close"
          ></customer-send-webchat>
        </div>
      </div>
      <div class="layerClose">
        <v-btn flat icon @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import {mapGetters} from 'vuex'
import customerSendLine from './customerSendLine'
import customerSendWebchat from './customerSendWebchat'

export default {
  name: 'customerSendDialog',
  components: {
    customerSendLine,
    customerSendWebchat
  },
  computed: {
    ...mapGetters([
      'currentBrandId'
    ])
  },
  props: {
    sendDialog: {
      type: Boolean,
      default: false
    },
    sendCustomerList: {
      type: Array
    },
    customerTabStat: {
      type: String
    },
    mailSendCheck: {
      type: Boolean
    }
  },
  data () {
    return {
      loading: false,
      templateList: []
    }
  },
  created () {
  },
  mounted () {
  },
  watch: {
    sendDialog (val) {
      if (!val) {
      } else {
        this.templateListCall()
      }
    }
  },
  methods: {
    close () {
      this.$emit('sendDialogClose')
      if (this.$refs.sendLine) {
        this.$refs.sendLine.resetLineParam()
      }
      if (this.$refs.sendWebChat) {
        this.$refs.sendWebChat.resetWebChatParam()
      }
    },
    templateListCall () {
      this.$http.get(`/api/marketing/list`, {
        params: {
          brandId: this.currentBrandId,
          moduleChannelType: this.customerTabStat === 'LINE' ? this.customerTabStat : 'WEB_CHAT'
        }
      })
        .then(result => {
          const response = result.data
          if (response.code === 0) {
            let data = response.data
            if (data) {
              data.filter(list => list.marketingStatus === 'ENABLE').forEach(list => {
                this.templateList.push({
                  value: list.marketingId,
                  name: list.marketingName
                })
              })
            }
          } else {
            throw response.message
          }
        }).catch(errorMsg => {
          this.$alertMsg(errorMsg)
        })
    }
  }
}
</script>

<style lang="scss">
.groupDialogBox {
  dl.groupList {
    padding-bottom: 10px;
    dt {
      padding-bottom:5px;
      color:$gray-8;
      font-weight: bold;
      font-size: 14px;
    }
    dd {
      border:1px solid #C4C4C4;
      border-radius: 3px;
      ul {
        padding:10px;
        height:140px;
        overflow-y:auto;
        li {
          padding: 0 5px 5px 0;
          list-style: none;
          display: inline-flex;
          justify-content: flex-start;
          align-items: center;
          span {
            padding:0 10px;
            display:inline-block;
            height:35px;
            line-height:35px;
            font-size: 14px;
            color: $gray-8;
            background: $gray-2;
            border-radius: 3px;
          }
        }
      }
    }
  }
  .requiredTxt {
    display: flex;
    justify-content: end;
    font-size: 11px;
    color: #939393;
  }
  td .v-input--is-disabled input {
    color: #aaa;
  }
  .UXTbl tbody td {
    height: 65px;
  }
  .left {
    float : left;
    padding-right: 10px;
  }
  .v-chip--select-multi {
    background: #E8E8E8;
  }
  .disableColor {
    opacity: 0.4;
  }
  .v-select.v-text-field input::placeholder {
    color: #555555;
  }
  .layerPopup {
    padding: 20px 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/menus/customer/components/customerSendDialog.vue